/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import type { Theme } from '@coursera/cds-core';
import { Accordion, AccordionHeader, AccordionPanel, Typography2, useTheme } from '@coursera/cds-core';

import { CML } from 'bundles/cml';
import type { TextBlockElement } from 'bundles/compound-assessments/components/api/types/CompoundAssessmentsForm';

export type Props = {
  title?: TextBlockElement['title'];
  body: TextBlockElement['body'];
  expanded?: boolean;
};

const styles = {
  accordionPanel: (theme: Theme) =>
    css({
      marginTop: theme.spacing(16),
    }),
};

const TextBlock = ({ title, body, expanded }: Props) => {
  const theme = useTheme();

  return (
    <Accordion variant="silent" defaultExpanded={expanded}>
      <AccordionHeader label={title || ''} />
      <AccordionPanel>
        <Typography2 component="div" variant="bodyPrimary" css={styles.accordionPanel(theme)}>
          <CML cml={body} />
        </Typography2>
      </AccordionPanel>
    </Accordion>
  );
};

export default TextBlock;
